<template>
  <div class="course-list">
    <mk-tabs-biz
      v-model="tabValue"
      class="el-tabs-mk-ui"
    >
      <mk-tab-pane
        v-for="item in tabList"
        :key="item.name"
        :label="item.label"
        :name="item.name"
      />
    </mk-tabs-biz>

    <component :is="tabValue+'-course-list'" />
  </div>
</template>

<script>
import InsideCourseList from './inside-course'
import OutsideCourseList from './outside-course'
export default {
  name: 'CourseList',
  components: { InsideCourseList, OutsideCourseList },
  data () {
    return {
      tabValue: 'inside',
      oemName: ''
    }
  },
  computed: {
    tabList () {
      return [
        {
          label: '内部课程',
          name: 'inside'
        },
        {
          label: this.oemName || '尘锋学院',
          name: 'outside'
        }
      ]
    }
  },
  watch: {
    tabValue (value) {
      this.util.storage.setItem('course-list-tab-value', value)
      this.util.storage.removeItem('stash-course-list-tab-value')
    }
  },
  created () {
    this.tabValue = this.util.storage.getItem('course-list-tab-value') || 'inside'
    this.oemName = this.util.gitCollegeName()
  },
  beforeDestroy () {
    if (this.util.storage.getItem('stash-course-list-tab-value') !== 'yes') {
      this.util.storage.removeItem('stash-course-list-tab-value')
      this.util.storage.removeItem('course-list-tab-value')
    }
  }
}
</script>

<style lang='scss' scoped>
.course-list {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
